module.exports = __webpack_public_path__ + "img/p87.4e85a3c7.jpg";